import React from 'react';

// function SkeletonLoader() {
//   return (
//     <div className="qp-skel-loader">
//       <div className="qp-skel-loader-inner">
//         <div className="spinner" />
//         <p>Loading…</p>
//       </div>
//     </div>
//   );
// }

function ListCardSkeleton({ pillCount = 2 }) {
  return (
    <div className="draft-order card card-expandable qp-skel-list-card">
      <div className="card__collapsible-button">
        <span className="card__title expandable-title">
          <div className="draft-order-title">
            <span className="skeleton-text skeleton-heading skeleton-width3 qp-skel-list-title" />
            {/* <span className="skeleton-text skeleton-width2 qp-skel-list-sub" /> */}
          </div>
          <div className="draft-order-status-container draft-order-status-expandable">
            {Array.from({ length: pillCount }).map((_, i) => (
              <span key={i} className="pill-button qp-skel-pill" />
            ))}
          </div>
        </span>
        <div className="total-amount-header">
        <span className="skeleton-text skeleton-heading skeleton-width2 qp-skel-list-amount" />
        <span className="skeleton-text skeleton-width1 qp-skel-list-total-label" />
          {/* <span className="skeleton-text skeleton-width1 qp-skel-list-items" /> */}
        </div>
        <span className="plus-button plus-button--large" aria-hidden="true" />
      </div>
    </div>
  );
}

function DetailSkeleton() {
  return (
    <div className="qp-skeleton skeleton-container" role="status" aria-label="Loading">
      {/* <SkeletonLoader /> */}
      <span className="skeleton-text skeleton-width3 qp-skel-back" />

      <div className="qp-skel-card">
        <div className="qp-skel-titlebar">
          <span className="skeleton-text skeleton-heading skeleton-width3" />
          <span className="skeleton-text skeleton-heading skeleton-width2 qp-skel-total" />
        </div>

        <div className="qp-skel-subline">
          <span className="skeleton-text skeleton-width4" />
          <span className="skeleton-text skeleton-width2" />
        </div>

        <div className="qp-skel-info">
          {[0, 1, 2].map((i) => (
            <div className="qp-skel-info-col" key={i}>
              <span className="skeleton-text skeleton-heading skeleton-width2" />
              <span className="skeleton-text skeleton-width3" />
              <span className="skeleton-text skeleton-width2" />
              <span className="skeleton-text skeleton-width1" />
            </div>
          ))}
        </div>

        <div className="qp-skel-items">
          {[0, 1, 2].map((i) => (
            <div className="qp-skel-item" key={i}>
              <div className="qp-skel-thumb">
                <div className="skeleton-image" />
              </div>
              <div className="qp-skel-item-meta">
                <span className="skeleton-text skeleton-heading skeleton-width4" />
                <span className="skeleton-text skeleton-width2" />
                <span className="skeleton-text skeleton-width3" />
              </div>
              <div className="qp-skel-item-price">
                <span className="skeleton-text skeleton-width2" />
              </div>
            </div>
          ))}
        </div>

        <div className="qp-skel-actions">
          <div className="qp-skel-btn" />
          <div className="qp-skel-btn" />
          <div className="qp-skel-btn" />
        </div>
      </div>
    </div>
  );
}

/**
 * Matches snippets/skeleton.liquid `quote-portal` (minus the nav pills —
 * PortalNav already mounts in App). Shown while data loads so React replacing
 * the Liquid skeleton does not flash a blank page.
 *
 * variant="list" — collapsed quote/order cards
 * variant="detail" — full order/quote detail (default)
 */
function PortalSkeleton({ variant = 'detail' }) {
  if (variant === 'list') {
    return (
      <div className="qp-skeleton qp-skeleton--list skeleton-container" role="status" aria-label="Loading">
        {/* <SkeletonLoader /> */}
        <ListCardSkeleton pillCount={2} />
        <ListCardSkeleton pillCount={3} />
        <ListCardSkeleton pillCount={1} />
      </div>
    );
  }

  return <DetailSkeleton />;
}

export default PortalSkeleton;
